"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var logger_const_1 = require("../const/logger.const");
var Logger = (function () {
    function Logger() {
    }
    Logger.prototype.message = function (value, type) {
        if (type === void 0) { type = logger_const_1.LOG_TYPE.info; }
        var env = process.env.NODE_ENV;
        var isPrimitive = !lodash_1.isObject(value) && !lodash_1.isArray(value);
        if (env === logger_const_1.ENV.local || env === logger_const_1.ENV.test) {
            if (isPrimitive) {
                console.log("%c " + value, this.getMessageColour(type));
            }
            else {
                console.table ? console.table(value) : console.log(value);
            }
        }
    };
    Logger.prototype.getMessageColour = function (type) {
        if (type === void 0) { type = logger_const_1.LOG_TYPE.info; }
        switch (type) {
            case logger_const_1.LOG_TYPE.error:
                return 'background: #DC143C; color: #fff';
            case logger_const_1.LOG_TYPE.warning:
                return 'background: #FFFF33; color: #000';
            case logger_const_1.LOG_TYPE.info:
            default:
                return 'background: #228B22; color: #fff';
        }
    };
    return Logger;
}());
exports.logger = new Logger();
